import React, { useState, useEffect, useRef } from 'react';
import { Checkbox } from './checkbox';
import {
  useFirebaseContext,
  useShowTaskEditOptionsContext,
  useShowTaskEditBoxContext,
  useAllInOneContext,
  useActiveListContext,
  useListRefContext,
} from '../../../context';
import { resizeOnInput } from '../../../helpers';
import { COLORS } from '../../../constants';
import { DndList } from '../../dnd_list';
import { Core } from '../..';
import { TimeDisplay } from './time-display';
import { ListRedirect } from './styles';
import { FaGripVertical, FaInfoCircle, FaStar } from 'react-icons/fa';
import { ItemContainer } from './styles';
import { OnlyHover } from '../../../media_queries';

export const IndividualTask = ({
  task,
  dragSnapshot,
  taskTotal,
  taskIndex,
  isKey = false,
  setProgress,
  isInDelete,
  setIsInDelete,
  targetTask,
  setTargetTask
}) => {
  const { firebase } = useFirebaseContext();
  const { lists, allTasks, setAllTasks } = useAllInOneContext();
  const [showOptions, setShowOptions] = useState(false);
  const { showTaskEditOptions } = useShowTaskEditOptionsContext();
  const { setShowTaskEditBox, setTargetEditTask } = useShowTaskEditBoxContext();
  const { activeList, setActiveList, themeColor } = useActiveListContext();
  const [listIndex, setListIndex] = useState();
  let { listRefs } = useListRefContext();
  const isDragging = dragSnapshot ? dragSnapshot.isDragging : null;
  const [tempTitle, setTempTitle] = useState(task.title);

  const textareaRef = useRef();

  useEffect(() => {
    if (lists)
      setListIndex(lists.findIndex((list) => list.docID == task.listID));
  }, [lists]);

  const changeTitle = () => {
    firebase
      .firestore()
      .collection('users')
      .doc(firebase.auth().currentUser.uid)
      .collection('tasks')
      .doc(task.docID)
      .update({
        title: tempTitle,
      });

    const temp = allTasks;
    temp[temp.findIndex((item) => item.docID == task.docID)].title = tempTitle;

    setAllTasks(temp);

    setActiveList();
    setActiveList(activeList);
  };

  useEffect(() => {
    if (task && textareaRef && textareaRef.current) {
      textareaRef.current.value = task.title;

      resizeOnInput(textareaRef.current);
    }
  }, [task, textareaRef, activeList]);

  return (
    <>
      <DndList.Item
        total={taskTotal}
        number={taskIndex + 1}
        isOnDrag={isDragging}
        forType='Task'
        parentType={isKey ? 'filter' : 'manual'}
        style={{
          padding: '10px',
          background: 'white',
          display: 'block',
          position: 'relative',
          opacity: isInDelete ? 0.6 : 1,
        }}
        onMouseLeave={() => setShowOptions(false)}
      >
        <OnlyHover showBox={showTaskEditOptions}>
          {!isKey && (
            <Core.HoverHandle
              forType='Task'
              color={themeColor}
              onMouseEnter={() => setShowOptions(true)}
              style={{
                position: 'absolute',
                left: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'grab',
                marginLeft: '15px',
                visibility:
                  isDragging || showTaskEditOptions || showOptions
                    ? 'visible'
                    : 'hidden',
              }}
            >
              <FaGripVertical className='icon' />
            </Core.HoverHandle>
          )}
        </OnlyHover>

        <OnlyHover showBox={showTaskEditOptions}>
          {(showTaskEditOptions || ((!isDragging || isKey) && showOptions)) && (
            <div
              style={{
                position: 'absolute',
                right: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 99,
              }}
              onMouseEnter={() => setShowOptions(true)}
            >
              <Core.HoverHandle
                forType='Task'
                style={{
                  marginRight: '15px',
                }}
                color={themeColor}
                onClick={() => {
                  setShowTaskEditBox(true);
                  setTargetEditTask(task);
                }}
              >
                <FaInfoCircle className='icon' />
              </Core.HoverHandle>
            </div>
          )}
        </OnlyHover>

        <ItemContainer
          onMouseEnter={() => setShowOptions(true)}
          onMouseLeave={() => setShowOptions(false)}
          style={{
            height: '100%',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'start' }}>
            <Checkbox
              targetTask={targetTask}
              setTargetTask={setTargetTask}
              isInDelete={isInDelete}
              setIsInDelete={setIsInDelete}
              setProgress={setProgress}
              task={task}
            />
            <div
              style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                marginLeft: '8px',
                overflow: 'hidden',
              }}
            >
              <Core.TextArea
                style={{
                  background: 'rgba(0,0,0,0.05)',
                }}
                targetType='task'
                forwardedRef={textareaRef}
                type='text'
                value={tempTitle}
                onChange={(e) => {
                  resizeOnInput(e.target);
                  setTempTitle(e.target.value);
                }}
                rows='1'
                onBlur={() => changeTitle()}
              ></Core.TextArea>
              {task.date && task.date != '' && (
                <TimeDisplay
                  task={task}
                  style={{ marginTop: '9px', marginLeft: '5px' }}
                />
              )}
              {task.note != '' && (
                <div
                  style={{
                    wordBreak: 'break-all',
                    color: 'rgba(0,0,0,0.55)',
                    marginTop: '9px',
                    marginLeft: '5px',
                  }}
                >
                  {task.note}
                </div>
              )}
              {task.listID != activeList && lists && listIndex > -1 && (
                <ListRedirect
                  color={COLORS[lists[listIndex].color]}
                  className='smallScreen'
                  style={{ marginLeft: '8px' }}
                  onClick={() => {
                    listRefs[listIndex].click();
                  }}
                >
                  {lists[listIndex].name}
                </ListRedirect>
              )}
            </div>

            {task.important && (
              <div
                style={{
                  marginLeft: '8px',
                  color: '#f09a37',
                  fontSize: '25px',
                }}
              >
                <FaStar />
              </div>
            )}

            {task.listID != activeList && lists && listIndex > -1 && (
              <ListRedirect
                color={COLORS[lists[listIndex].color]}
                className='largeScreen'
                style={{ marginLeft: '8px' }}
                onClick={() => {
                  listRefs[listIndex].click();
                }}
              >
                {lists[listIndex].name}
              </ListRedirect>
            )}
          </div>
        </ItemContainer>
      </DndList.Item>
    </>
  );
};
